import config from "../../app.json";
import axios from "axios";

import { emailValidation } from "../../helper";
import { Context } from "../../Reducers/Store";
import { Row, Col, Button } from "react-bootstrap";
import React, { useState, useContext, useEffect } from "react";
import FieldText from "../Fields/FieldText";
import AlertComponent from "../AlertComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

import { Elements, useStripe, useElements, CardCvcElement, CardNumberElement, CardExpiryElement } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(config.STRIPE);

import "./EditBilling.scss";

const EditBilling = (props) => {
  const [billingEmail, setBillingEmail] = useState(null);

  const handleCardToken = (error, token) => {
    if (error) {
      AlertComponent("Error", error.message, { icon: `error` });
    } else {
      const payload = {
        stripeCardToken: token.id,
        billingEmail: billingEmail,
      };
      axios
        .put(config.API_HM + "/subscriptions/billing", payload)
        .then((res) => {
          if (props.setShowEditingBilling) {
            props.setShowEditingBilling(false);
          }
          AlertComponent("Success", "The billing info has been updated.");
        })
        .catch(function (error) {
          AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
        });
    }
  };

  return (
    <div className="edit-billing-info">
      <Row>
        <Elements stripe={stripePromise} options={{ appearance: { theme: "flat" } }}>
          <SubmitForm callbackCardToken={handleCardToken} changeBillingEmail={setBillingEmail} setShowEditingBilling={props.setShowEditingBilling} />
        </Elements>
      </Row>
    </div>
  );
};
export default EditBilling;

const SubmitForm = ({ callbackCardToken, changeBillingEmail, setShowEditingBilling }) => {
  const [state, dispatch] = useContext(Context);
  const [billingEmail, setBillingEmail] = useState(null);
  const [billingMailError, setBillingMailError] = useState(null);

  const handleBillingEmail = (value) => {
    changeBillingEmail(value);
    setBillingEmail(value);
  };

  const stripe = useStripe();
  const elements = useElements({ theme: "stripe" });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!emailValidation(billingEmail)) {
      setBillingMailError("Invalid email");
      return false;
    }
    setBillingMailError(null);
    return true;
  };

  const handleCancel = () => {
    setShowEditingBilling(false);
  };
  const fetchCardToken = async (e) => {
    if (!handleSubmit(e)) {
      return;
    }

    const cardElement = elements.getElement(CardNumberElement);

    dispatch({ type: "SET_LOADING", payload: true });
    const ret = await stripe.createToken(cardElement, {
      type: "card",
    });
    dispatch({ type: "SET_LOADING", payload: false });

    callbackCardToken(ret.error, ret.token);
  };

  return (
    <div className="stripe-container">
      <div className={`stripe-elements`}>
        <Row>
          <Col md={12}>
            <FieldText
              label="Billing Email"
              type="email"
              onChange={(x) => handleBillingEmail(x.target.value)}
              placeholder="Email address"
              value={billingEmail}
              error={billingMailError}
              required={true}
            />
          </Col>
        </Row>
        <Row>
          <Col className="col-md-6">
            <div className="form-group">
              <label>Card number</label>
              <CardNumberElement
                className="stripe-input"
                options={{
                  showIcon: true,
                  classes: { base: "form-control" },
                }}
              />
            </div>
          </Col>
          <Col className="col-md-3">
            <div className="form-group">
              <label>Expiration</label>
              <CardExpiryElement className="stripe-input" options={{ classes: { base: "form-control" } }} />
            </div>
          </Col>
          <Col className="col-md-3">
            <div className="form-group">
              <label>CVC</label>
              <CardCvcElement className="stripe-input" options={{ classes: { base: "form-control" } }} />
            </div>
          </Col>
        </Row>
        <Row>
          <div>
            <span className="plan-lock">
              <FontAwesomeIcon icon={faLock}></FontAwesomeIcon>
            </span>
            <span className="plan-lock-instruction">Secured form with Stripe</span>
          </div>
          <div className="pay-text">
            <span className="text-muted">By clicking in `Update`, you agree to change your card info.</span>
          </div>
          <div className="pay-btn">
            <Button type="submit" className={`btn btn-primary`} onClick={fetchCardToken}>
              Update
            </Button>

            <Button type="submit" className={`btn btn-danger cancel-btn`} onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </Row>
      </div>
    </div>
  );
};
